module.exports = __webpack_public_path__ + "img/armageddon.ef9a37ba.png";